import { updateFilters, getFilters } from "@components/helper/localStorageHelper";

export default {
  namespaced: true,
  state: {
    filters: {},
  },
  mutations: {
    setFilters(state, { key, filters }) {
      state.filters = filters;
      updateFilters(key, filters);
    },
    /** Clear in-memory filters only — does not touch localStorage / filtersByAccess. */
    clearInMemoryFilters(state) {
      state.filters = {};
    },
  },
  getters: {
    getFilters: (state) => state.filters,
  },
  actions: {
    updateFilters({ commit }, { key, filters }) {
      commit("setFilters", { key, filters });
    },
    loadFilters({ commit }, key) {
      const savedFilters = getFilters(key);
      commit("setFilters", { key, filters: savedFilters || {} });
    },
    clearInMemoryFilters({ commit }) {
      commit("clearInMemoryFilters");
    },
  },
};
